import { logError } from "../../../utils/error";
const SYSTEM_PROMPT_KEY = "enlighten_ragchat_system_prompt";
const DEFAULT_SYSTEM_PROMPT = "";

/**
 * Saves the custom system prompt to localStorage
 * @param systemPrompt - The system prompt to save
 */
export const saveSystemPrompt = (systemPrompt: string): void => {
  try {
    localStorage.setItem(SYSTEM_PROMPT_KEY, systemPrompt);
  } catch (error) {
    logError("Failed to save system prompt to localStorage", error);
  }
};

/**
 * Retrieves the saved system prompt from localStorage
 * @returns The saved system prompt or default value if not found
 */
export const getSavedSystemPrompt = (): string => {
  try {
    const savedValue = localStorage.getItem(SYSTEM_PROMPT_KEY);
    return savedValue !== null ? savedValue : DEFAULT_SYSTEM_PROMPT;
  } catch (error) {
    logError("Failed to retrieve system prompt from localStorage", error);
    return DEFAULT_SYSTEM_PROMPT;
  }
};

/**
 * Checks if a custom system prompt is saved in localStorage
 * @returns True if a custom system prompt exists
 */
export const hasCustomSystemPrompt = (): boolean => {
  try {
    const savedValue = localStorage.getItem(SYSTEM_PROMPT_KEY);
    return savedValue !== null && savedValue.trim() !== "";
  } catch (error) {
    logError("Failed to check for custom system prompt in localStorage", error);
    return false;
  }
};

/**
 * Resets the system prompt in localStorage to default (removing it)
 */
export const resetSystemPrompt = (): void => {
  try {
    localStorage.removeItem(SYSTEM_PROMPT_KEY);
  } catch (error) {
    logError("Failed to reset system prompt in localStorage", error);
  }
};
